import { render, staticRenderFns } from "./AssetTypeSelect.vue?vue&type=template&id=4073ee58"
import script from "./AssetTypeSelect.vue?vue&type=script&lang=ts"
export * from "./AssetTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports